/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UserRole = "ADMIN" | "%future added value";
export type AddUserRoleInput = {
    userId: string;
    role: UserRole;
    clientMutationId?: string | null | undefined;
};
export type userDetailsAddUserRoleMutationVariables = {
    input: AddUserRoleInput;
};
export type userDetailsAddUserRoleMutationResponse = {
    readonly addUserRole: {
        readonly clientMutationId: string | null;
    } | null;
};
export type userDetailsAddUserRoleMutation = {
    readonly response: userDetailsAddUserRoleMutationResponse;
    readonly variables: userDetailsAddUserRoleMutationVariables;
};



/*
mutation userDetailsAddUserRoleMutation(
  $input: AddUserRoleInput!
) {
  addUserRole(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddUserRolePayload",
    "kind": "LinkedField",
    "name": "addUserRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userDetailsAddUserRoleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userDetailsAddUserRoleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "625665acdfb27e83b59728600cceabd5",
    "id": null,
    "metadata": {},
    "name": "userDetailsAddUserRoleMutation",
    "operationKind": "mutation",
    "text": "mutation userDetailsAddUserRoleMutation(\n  $input: AddUserRoleInput!\n) {\n  addUserRole(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '8aec0d1fddc27d92ceff919dae427a21';
export default node;
